import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setWorkflowId,
  setWorkflowTemplateId,
} from "ReduxStore/Slices/workflowSlice";
import { createWorkflow } from "components/Workflow_Components/Api";
import { useHistory } from "react-router-dom";
import "../automation.css";
import { toast } from "react-toastify";

export default function SelectAutomationCard({
  name,
  description,
  workflowTemplateId,
  icon_url,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const workflowData = useSelector((state) => state.workflowSetter);
  const handleCreateAutomation = () => {
    dispatch(setWorkflowTemplateId(workflowTemplateId));

    workflowData.workflowName !== "" && workflowData.workflowDescription !== ""
      ? createWorkflow(
        workflowData.workflowName,
        workflowData.workflowDescription,
        workflowData.workflowRerunFlag,
        workflowTemplateId
      )
        .then((res) => {
          dispatch(setWorkflowId(res.data.id));
          history.push(`/admin/workflow/automationstudio/create`);
        })
        .catch((err) => {

        })
      : toast.info("Please enter workflow name and description");
  };
  return (
    <div className="cardOutter" style={{ width: "100%" }}>
      <div class="card  mt-5 " style={{ width: "90%", border: "none" }}>
        <div class="row ">
          <div class="col-md-2">
            {/* <img src="..." class="img-fluid rounded-start" alt="..."> */}
            <div
              style={{
                maxWidth: "10em",
                maxHeight: "10em",
                // backgroundColor: "#F6F7FF",
                borderRadius: "5px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "transparent",
              }}
            >
              <img
                alt="Kapitalwise"
                style={{ height: "100%", width: "100%", padding: "1.5rem" }}
                src={icon_url}
              />
            </div>
          </div>
          <div class="col-md-10">
            <div class="card-body" style={{ padding: "0px", height: "100%" }}>
              <h5 class="card-title">{name}</h5>
              <p class="card-text">{description}</p>
              <div className="cardbottom">
                <a
                  to=""
                  className="lg_btn primary"
                  onClick={handleCreateAutomation}
                  type="submit"
                >
                  Continue
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
